import {
	AppBar,
	Dialog,
	InputBase,
	MenuItem,
	Select,
	Slide,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { setIdreminderOpen, setPwreminderOpen } from 'src/actions/login';
import { LmBasicRouteProps } from 'src/utils/routerSupportTypes';
import { initializeStore } from '../actions/common';
import { IMessage, showMessage } from '../actions/message';
import LoginNotice from '../components/LoginNotice';
import MessageDialog from '../components/MessageDialog';
import Progress from '../components/Progress';
import LangString from '../Lang.json';
import { IRootState } from '../reducers';
import { ILoginState } from '../reducers/login';
import i18n from '../resources/i18n';
import * as Scenario from '../scenario/login';
import PwrPwReminder, { PwrFormType, pwrFormType } from './PwrPwReminder';

// import backgroundImage from '../images/login_bg.jpg';
import logoImage from '../images/logo.png';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		appHeader: {
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(1),
				width: '100%',
			},
		},
		appMain: {
			paddingLeft: theme.spacing(4),
			paddingRight: theme.spacing(4),
			[theme.breakpoints.up('md')]: {
				alignItems: 'center',
				display: 'flex',
				flexDirection: 'column',
				paddingTop: theme.spacing(20),
			},
		},
		bootstrapInput: {
			'&:focus': {
				borderColor: '#80bdff',
				boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
			},
			backgroundColor: theme.palette.common.white,
			border: '1px solid #ced4da',
			borderRadius: 4,
			fontSize: 16,
			padding: '10px 12px',
			transition: theme.transitions.create([
				'border-color',
				'box-shadow',
			]),
			width: 'calc(100% - 24px)',
		},
		bootstrapRoot: {
			'label + &': {
				marginTop: theme.spacing(3),
			},
			padding: 0,
		},
		careerDialog: {
			width: '80%',
		},
		container: {
			[theme.breakpoints.up('md')]: {
				display: 'flex',
				flexDirection: 'row-reverse',
				flexWrap: 'wrap',
				width: '960px',
			},
		},
		form: {
			maxWidth: '100%', // for I.E.
		},
		formControl: {
			backgroundColor: 'white',
			marginBottom: theme.spacing(1),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
		},
		link: {
			color: 'white',
			cursor: 'pointer',
			textDecoration: 'underline',
		},
		loginForm: {
			paddingBottom: theme.spacing(1),
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(1),
				width: '300px',
			},
		},
		loginNotice: {
			[theme.breakpoints.up('md')]: {
				flex: 1,
				padding: theme.spacing(1),
				width: '660px',
			},
		},
		logoBox: {
			[theme.breakpoints.up('md')]: {
				// margin: 0,
				// maxWidth: '1020px',
			},
		},
		paper: {
			alignItems: 'center',
			backgroundColor: 'rgba(192,255,255,0.2)',
			color: 'white',
			display: 'flex',
			flexDirection: 'column',
			padding: `${theme.spacing(2)}px ${theme.spacing(
				3
			)}px ${theme.spacing(3)}px`,
		},
		root: {
			backgroundColor: '#257ec0',
			// backgroundImage: `url(${backgroundImage})`,
			backgroundSize: 'cover',
			minHeight: '100vh',
			minWidth: '100vw',
		},
		submit: {
			marginTop: theme.spacing(3),
		},
	});
const BootstrapInput = withStyles(theme => ({
	input: {
		'&:focus': {
			borderColor: '#80bdff',
			borderRadius: 4,
			boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
		},
		backgroundColor: theme.palette.background.paper,
		border: '1px solid #ced4da',
		borderRadius: 4,
		// Use the system font instead of the default Roboto font.
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		fontSize: 16,
		padding: '10px 26px 10px 12px',
		position: 'relative',
		transition: theme.transitions.create(['border-color', 'box-shadow']),
	},
	root: {
		'label + &': {
			marginTop: theme.spacing(3),
		},
	},
}))(InputBase);

// tslint:disable-next-line:no-empty-interface
export interface ILoginProps {}

interface IHeaderProps extends WithStyles<typeof styles> {
	showCMOption: boolean;
}
interface IState {
	userName: string;
	password: string;
	showCMOption: boolean;
	localLang: string;
	langListAll: string[];
}

/**
 * ログインフォームProps型
 */
export type ILoginFormProps = IProps['pwr'];

/**
 * ログイン画面用コンポーネント
 */
class Login extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		let LngItem = '';
		const langList = [];
		// tslint:disable-next-line:forin
		for (const i in LangString) {
			langList.push(i);
		}
		if (langList.indexOf(i18n.language) === -1) {
			LngItem = 'ja';
		} else {
			LngItem = i18n.language;
		}
		this.state = {
			langListAll: langList,
			localLang: LngItem,
			password: '',
			showCMOption: false,
			userName: '',
		};
	}

	/**
	 * 画面描画時処理
	 * 管理者からのお知らせを取得し、画面表示する
	 */
	public async componentDidMount() {
		await this.props.initializeStore();
		if (this.props.fetchedMessagesAt) {
			return;
		}
		this.props.fetchMessages(this.props.match.params.company_code);
	}

	/**
	 * 画面描画処理
	 */
	public render() {
		const { classes, isShowProgress, pwr } = this.props;
		const headerProps: IHeaderProps = {
			classes,
			showCMOption: this.props.showCMOption,
		};

		return (
			<div className={classes.root}>
				<Progress open={isShowProgress} />
				<main className={classes.appMain}>
					<div className={classes.container}>
						<this.Header {...headerProps} />
						<this.LoginForm {...pwr} />
						<div className={classes.loginNotice}>
							<LoginNotice
								messages={this.props.messages}
								interval={this.props.carouselChangeInterval}
							/>
						</div>
					</div>
				</main>

				<MessageDialog
					open={this.props.message.open}
					contents={this.props.message.messages}
					title={this.props.message.title}
					showCancelButton={false}
					onClickOk={this.handleDialogClose}
					onClose={this.handleDialogClose}
					messageNs="loginmessage"
				/>

				<this.PasswordReissueDialog pwr={pwr} />
				<this.LoginIdNotificationAndPasswordReissueDialog pwr={pwr} />
			</div>
		);
	}

	/**
	 * ログインフォーム
	 */
	protected LoginForm: React.FC<ILoginFormProps> = ({
		loginIdLinkEnabled: idRemind,
		passwordLinkEnabled: pwRemind,
	}) => {
		const { classes } = this.props;

		return (
			<div className={classes.loginForm}>
				<Paper className={classes.paper}>
					<form
						noValidate={true}
						autoComplete="off"
						className={classes.form}
					>
						{this.props.showLangOption ? (
							<FormControl
								margin="normal"
								required={true}
								fullWidth={true}
							>
								<Select
									id="langItem"
									variant="outlined"
									value={this.state.localLang}
									onChange={this.onChangeSelectLang}
									input={<BootstrapInput />}
								>
									{this.state.langListAll.map(
										(
											lang: string,
											i: number
										): JSX.Element => (
											<MenuItem value={lang}>
												{LangString[lang]}
											</MenuItem>
										)
									)}
								</Select>
							</FormControl>
						) : null}
						<FormControl
							margin="normal"
							required={true}
							fullWidth={true}
						>
							<Input
								id="userName"
								name="userName"
								value={this.state.userName}
								placeholder={i18n.t('Login_0001')}
								onChange={this.handleChange('userName')}
								onKeyPress={this.handleKeyPress}
								autoFocus={true}
								disableUnderline={true}
								classes={{
									input: classes.bootstrapInput,
									root: classes.bootstrapRoot,
								}}
							/>
						</FormControl>
						<FormControl
							margin="normal"
							required={true}
							fullWidth={true}
						>
							<Input
								id="password"
								name="password"
								type="password"
								value={this.state.password}
								placeholder={i18n.t('Login_0002')}
								onChange={this.handleChange('password')}
								onKeyPress={this.handleKeyPress}
								disableUnderline={true}
								classes={{
									input: classes.bootstrapInput,
									root: classes.bootstrapRoot,
								}}
							/>
						</FormControl>
						<Button
							variant="contained"
							color="primary"
							fullWidth={true}
							onClick={this.handleLogin}
							className={classes.submit}
						>
							{i18n.t('Login_0003')}
						</Button>
						{idRemind || pwRemind ? (
							<FormControl
								margin="normal"
								required={true}
								fullWidth={true}
							>
								{pwRemind ? (
									<span
										className={this.props.classes.link}
										onClick={this.props.openPwreminder}
									>
										{i18n.t('Login_0004')}
									</span>
								) : null}
								{idRemind ? (
									<span
										className={this.props.classes.link}
										onClick={this.props.openIdreminder}
									>
										{i18n.t('Login_0005')}
									</span>
								) : null}
							</FormControl>
						) : null}
					</form>
				</Paper>
			</div>
		);
	};

	/**
	 * 言語変更処理
	 * @param event
	 */
	protected onChangeSelectLang(event: React.ChangeEvent<HTMLSelectElement>) {
		const { value } = event.target;
		i18n.changeLanguage(value);
		window.location.reload();
	}

	/**
	 * 入力項目変更処理
	 */
	protected handleChange = (name: string) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		this.setState({
			...this.state,
			[name]: target.value,
		});
	};

	/**
	 * キー入力処理
	 * Enterキーが押された際、ログインする
	 */
	protected handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter') {
			this.handleLogin();
		}
	};

	/**
	 * ログイン処理
	 */
	protected handleLogin = () => {
		let companyCode = '';
		if (
			this.props.match &&
			this.props.match.params &&
			this.props.match.params.company_code
		) {
			companyCode = this.props.match.params.company_code;
		}
		this.props.login(
			companyCode,
			this.state.userName as string,
			this.state.password as string
		);
	};

	/**
	 * ダイアログ非表示処理
	 */
	protected handleDialogClose = () => {
		this.props.showMessage([], '');
	};

	/**
	 * ヘッダ部コンポーネント
	 */
	protected Header: React.FC<IHeaderProps> = (headerProps: IHeaderProps) => (
		<header className={headerProps.classes.appHeader}>
			<div className={headerProps.classes.logoBox}>
				<img src={logoImage} />
			</div>
		</header>
	);

	private PwrAppBar: React.FC<{
		type: PwrFormType;
	}> = ({ type }) => {
		const label = (() => {
			switch (type) {
				case 'PASSWORD_REISSUE':
					return i18n.t('Login_0006');
				case 'LOGIN_ID_NOTIFICATION':
					return i18n.t('Login_0007');
				default:
					const exhaustives: never = type;
					throw exhaustives;
			}
		})();
		return (
			<AppBar className={this.props.classes.appBar}>
				<Toolbar>
					<Typography variant="h6" color="inherit">
						{i18n.t(label)}
					</Typography>
				</Toolbar>
			</AppBar>
		);
	};

	private PwrDialog: React.FC<{
		open: boolean;
		pwr: ILoginState['pwr'];
		type: PwrFormType;
	}> = ({ type, open, pwr }) => (
		<Dialog
			fullScreen={false}
			TransitionComponent={Transition}
			open={open}
			fullWidth={true}
			maxWidth={false}
			classes={{
				paperFullWidth: this.props.classes.careerDialog,
			}}
		>
			<this.PwrAppBar type={type} />
			<PwrPwReminder
				primary={pwr.identifierKey}
				type={type}
				identificationItems={pwr.identificationItems}
				identifierInput={pwr.identifyInput}
				companyCode={this.props.match.params.company_code}
				showMessage={this.props.showMessage}
				sendmailEndOpen={this.props.pwr.sendmailEndOpen}
			/>
		</Dialog>
	);

	private PasswordReissueDialog: React.FC<{ pwr: ILoginState['pwr'] }> = ({
		pwr,
	}) => (
		<this.PwrDialog
			type={pwrFormType.PASSWORD_REISSUE}
			pwr={pwr}
			open={this.props.pwr.pwreminderOpen}
		/>
	);

	private LoginIdNotificationAndPasswordReissueDialog: React.FC<{
		pwr: ILoginState['pwr'];
	}> = ({ pwr }) => (
		<this.PwrDialog
			type={pwrFormType.LOGIN_ID_NOTIFICATION}
			pwr={pwr}
			open={this.props.pwr.idreminderOpen}
		/>
	);
}

const mapStateToProps = (state: IRootState) => ({
	carouselChangeInterval: state.login.carouselChangeInterval,
	fetchedMessagesAt: state.login.fetchedMessagesAt,
	isShowProgress: state.login.isShowProgress,
	message: state.message,
	messages: state.login.messages,
	pwr: state.login.pwr,
	showCMOption: state.login.showCMOption,
	showLangOption: state.login.showLangOption,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchMessages: (companyCode: string | undefined) =>
		Scenario.fetchMessages(dispatch, companyCode),
	initializeStore: () => dispatch(initializeStore({})),
	login: (companyCode: string, userName: string, password: string) =>
		Scenario.login(dispatch, companyCode, userName, password),
	openIdreminder: () => {
		dispatch(setIdreminderOpen({ idreminderOpen: true }));
	},
	openPwreminder: () => {
		dispatch(setPwreminderOpen({ pwreminderOpen: true }));
	},
	showMessage: (messages: IMessage[], title: string) =>
		dispatch(showMessage({ messages, title })),
});

const Transition: React.FC<any> = props => {
	return <Slide direction="up" {...props} />;
};

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ILoginProps & LmBasicRouteProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(Login);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ILoginProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/Login.tsx